import * as React from 'react';
import styles from './index.less';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import FCoverImage from '@/components/FCoverImage';
import FDrawer from '@/components/FDrawer';
import { BaseInfo, OverflowTooltip } from '@/components/FCollectionItems2/CollectionList';
import moment from 'moment';

interface ChangeLogDrawerProps {
  collectionID: string;
  open: boolean;

  onClose?(): void;
}

interface ChangeLogDrawerStates {
  list: {
    updateTime: string;
    operations: {
      operationType: 'ADD' | 'DELETE' | 'CREATE';
      resources: {
        id: string;
        cover: string;
        name: string;
        title: string;
        version: string;
        policy: string[];
        type: string[];
        status: 0 | 1 | 2 | 4;
        authProblem: boolean;
        updateDate: string;
        username: string;
        useAvatar: string;
        isChoice: boolean;
        intro: string;
      }[];
    }[]
  }[];
}

function ChangeLogDrawer({ collectionID, open, onClose }: ChangeLogDrawerProps) {

  const [$list, set$list] = FUtil.Hook.useGetState<ChangeLogDrawerStates['list']>([]);

  async function fetchData() {
    const { data: data_logs }: {
      data: {
        skip: number;
        limit: number;
        totalItem: number;
        dataList: {
          resourceId: string;
          // "resourceVersionId": "776f84519f240f196e92f10dab3dd660",
          operations: {
            operationType: 'ADD' | 'DELETE' | 'CREATE',
            operationItems: {
              itemId: string;
              itemTitle: string;
              resourceId: string;
              resourceName: string;
              userId: number;
              username: string;
              coverImages: string[];
              intro: string;
              resourceType: string[];
              latestVersionReleaseDate: string;
            }[]
          }[],
          createDate: string;
        }[];
      }
    } = await FServiceAPI.Resource.getCollectionUpdateLogs({
      skip: 0,
      limit: 100,
      resourceId: collectionID,
      sortType: -1,
    });

    // console.log(data_logs, 'data sadifjasdl;kfjl;sadjlkfjlksdjlkj (((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((((');

    const resourceIDs: string[] = data_logs.dataList.map((dl) => {
      return dl.operations.map((o) => {
        return o.operationItems.map((oi) => {
          return oi.resourceId;
        });
      });
    }).flat(2);
    // console.log(resourceIDs, 'resourceIDs siodfj;lkaJDSlkfjlk');

    // let data_batchResources: Awaited<ReturnType<typeof FServiceAPI.Resource.batchInfo>>['data'] = [];
    let data_batchResources: any[] = [];

    if (resourceIDs.length > 0) {
      const { data } = await FServiceAPI.Resource.batchInfo({
        resourceIds: resourceIDs.join(','),
      });

      data_batchResources = data;
    }

    // console.log(data_batchResources, 'data_batchResources sadifhja;lsdjflkjlksdjlkj');
    const result: ChangeLogDrawerStates['list'] = data_logs.dataList
      .map<ChangeLogDrawerStates['list'][number]>((dl) => {
        // console.log(rrr, 'rrr sdifj;lskdjflkjlk');
        return {
          updateTime: moment(dl.createDate).format('YYYY-MM-DD HH:mm'),
          operations: dl.operations.map<ChangeLogDrawerStates['list'][number]['operations'][number]>((o) => {
            return {
              operationType: o.operationType,
              resources: o.operationItems.map<ChangeLogDrawerStates['list'][number]['operations'][number]['resources'][number]>((oi) => {
                const rrr = data_batchResources.find((br) => {
                  return br.resourceId === oi.resourceId;
                });
                return {
                  id: oi.resourceId,
                  cover: oi.coverImages[0] || '',
                  name: oi.resourceName,
                  title: rrr?.resourceTitle || '',
                  version: rrr?.latestVersion || '',
                  policy: rrr?.policies.map((p: any) => {
                    return p.policyName;
                  }) || [],
                  type: rrr?.resourceType || [],
                  status: rrr?.status || 0,
                  authProblem: false,
                  updateDate: moment(rrr?.updateDate).format('YYYY-MM-DD'),
                  username: oi.username,
                  useAvatar: `//image.freelog.com/avatar/${oi.userId}`,
                  isChoice: false,
                  intro: rrr?.intro || '',
                };
              }),
            };
          }),
        };
      });
    // console.log(result, 'result isjd;oflijs;dlkfjlk;sdjl;jkl;');
    set$list(result);
  }

  return (<FDrawer
    width={700}
    open={open}
    onClose={onClose}
    title={FI18n.i18nNext.t('edit_collection_itemmgnt_changelogs_title')}
    afterOpenChange={(open) => {
      if (open) {
        fetchData();
      }
    }}
  >
    {/*<div style={{ height: 30 }} />*/}
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: 30 }}>
      {
        $list.map((l, l_index) => {
          return (<div key={l_index}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <FComponentsLib.FContentText
                text={l.updateTime}
                type={'highlight'}
              />
            </div>
            {
              l.operations.map((o,o_index) => {
                return (<React.Fragment key={o_index}>
                  <div style={{ height: 15 }} />

                  {
                    o.operationType === 'CREATE' && (<FComponentsLib.FContentText
                      text={FI18n.i18nNext.t('edit_collection_itemmgnt_changelogs_initial')}
                      type={'additional2'}
                      style={{ color: '#42C28C', fontWeight: 600, fontSize: 14 }}
                    />)
                  }

                  {
                    o.operationType === 'ADD' && (<FComponentsLib.FContentText
                      text={FI18n.i18nNext.t('edit_collection_itemmgnt_changehistory_added')}
                      type={'additional2'}
                      style={{ color: '#42C28C', fontWeight: 600, fontSize: 14 }}
                    />)
                  }

                  {
                    o.operationType === 'DELETE' && (<FComponentsLib.FContentText
                      text={FI18n.i18nNext.t('edit_collection_itemmgnt_changehistory_removed')}
                      type={'additional2'}
                      style={{ color: '#EE4040', fontWeight: 600, fontSize: 14 }}
                    />)
                  }

                  {
                    o.resources.map((r) => {
                      return (<React.Fragment key={r.id}>
                        <div style={{ height: 5 }} />

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: 5 }}>
                          <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.03)',
                            borderRadius: 6,
                            padding: 10,
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}>
                            <FCoverImage
                              src={r.cover}
                              width={88}
                            />

                            <div style={{ width: 502, overflow: 'hidden' }}>
                              <OverflowTooltip
                                text={r.title || r.name.split('/')[0]}
                                className={styles.title}
                              />
                              <div style={{ height: 5 }} />
                              <OverflowTooltip
                                text={r.intro || '(暂无简介)'}
                                className={styles.intro}
                              />
                              <div style={{ height: 5 }} />
                              <BaseInfo resourceInfo={r} />
                            </div>
                          </div>
                        </div>
                      </React.Fragment>);
                    })
                  }
                </React.Fragment>);
              })
            }

          </div>);
        })
      }

    </div>
  </FDrawer>);
}

export default ChangeLogDrawer;
